export function attendanceCounts(employees, dateKey) {
  const totals = { present: 0, absent: 0, halfDay: 0, onLeave: 0, unmarked: 0 };
  for (const employee of employees) {
    const entries = (Array.isArray(employee.data) ? employee.data : []).filter(entry => {
      const date = new Date(entry.attendance_date);
      if (Number.isNaN(date.getTime())) return false;
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      return key === dateKey;
    });
    if (entries.some(entry => entry.type === "HalfDay")) totals.halfDay++;
    else if (entries.some(entry => ["SL", "PL"].includes(entry.type))) totals.onLeave++;
    else if (entries.some(entry => entry.attendance_status === "Y" || ["WFH", "LATE"].includes(entry.type))) totals.present++;
    else if (entries.some(entry => entry.attendance_status === "N")) totals.absent++;
    else totals.unmarked++;
  }
  return totals;
}
export function uniqueTasks(records) {
  return [...new Map(records.map((task, index) => [task.pk_taskid || task.pk_task_id || task.task_id || `row-${index}`, task])).values()];
}

export function parseJoiningDate(value) {
  if (!value) return null;
  const raw = String(value).trim();
  // Parse numeric dates explicitly; browser parsing differs for day-first dates.
  const iso = raw.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:$|[T\s,])/);
  const dayFirst = raw.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4}|\d{2})(?:$|[T\s,])/);
  if (iso || dayFirst) {
    const year = iso ? Number(iso[1]) : Number(dayFirst[3].length === 2 ? `20${dayFirst[3]}` : dayFirst[3]);
    const month = Number(iso ? iso[2] : dayFirst[2]);
    const day = Number(iso ? iso[3] : dayFirst[1]);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
  }
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
}
